import { render, staticRenderFns } from "./CheckoutB2C.vue?vue&type=template&id=3c6d92e2&scoped=true&"
import script from "./CheckoutB2C.vue?vue&type=script&lang=ts&"
export * from "./CheckoutB2C.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutB2C.vue?vue&type=style&index=0&id=3c6d92e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d92e2",
  null
  
)

export default component.exports